export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./legal.vue?vue&type=template&id=ee80141c"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/legal.vue?vue&type=template&id=ee80141c
// module id = Odn4
// module chunks = 0